import { render, staticRenderFns } from "./treatOthers.vue?vue&type=template&id=452158bc&scoped=true&"
import script from "./treatOthers.vue?vue&type=script&lang=js&"
export * from "./treatOthers.vue?vue&type=script&lang=js&"
import style0 from "./treatOthers.vue?vue&type=style&index=0&id=452158bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452158bc",
  null
  
)

export default component.exports